// IDs match the subscription dictionaries on Backend.
export const SubscriptionStatus = {
    TrialActive: 1,
    TrialExpiring: 2,
    Basic: 3,
    ProActive: 4,
    ProExpiring: 5,
    ProPaymentFailed: 6,
    ProCancelled: 7,
} as const;

export type SubscriptionStatusId = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];

export const SubscriptionPlan = {
    Trial: 1,
    Basic: 2,
    Pro: 3,
} as const;

export type SubscriptionPlanId = typeof SubscriptionPlan[keyof typeof SubscriptionPlan];

// Dates remain serializable ISO strings. Status is supplied by Backend.
export type Subscription = {
    id: string;
    userId: string;
    subscriptionStatusId: SubscriptionStatusId;
    subscriptionPlanId: SubscriptionPlanId;
    dateStart: string | null;
    dateEnd: string | null;
    isAutoRenewal: boolean;
    paymentMethod: string;
    billingPeriod: 1 | 12 | null;
    hasSavedPaymentMethod: boolean | null;
};

export type SubscriptionState = {
    data: Subscription | null;
    loading: 'idle' | 'pending' | 'success' | 'error';
    error: string | null;
    currentRequestId: string | null;
    requestUserId: string | null;
    paymentSync: {
        result: PaymentSyncResult | null;
        loading: 'idle' | 'pending' | 'success' | 'error';
        error: string | null;
        currentRequestId: string | null;
        requestUserId: string | null;
    };
    cancellation: {
        loading: 'idle' | 'pending' | 'success' | 'error';
        error: string | null;
        currentRequestId: string | null;
        requestUserId: string | null;
    };
};

export type SubscriptionPayment = {
    orderId: string;
    paymentId: string | null;
    period: 'Month' | 'Year';
    amount: number;
    currency: string;
    status: 'Creating' | 'Pending' | 'Succeeded' | 'Canceled' | 'NeedsReview';
    confirmationUrl: string | null;
    appliedAt: string | null;
    nextCheckAt: string | null;
    errorCode: string | null;
};

export type PaymentSyncResult = {
    payment: SubscriptionPayment;
    subscriptionUpdated: boolean;
};

// Structural state type avoids a runtime dependency on the application store.
export type SubscriptionRootState = {
    subscription: SubscriptionState;
    userAuthSettings: { isAuth: boolean; userId: string };
};
